import style from './Hall.module.css';
import Buttons from '../Buttons/Buttons';
import { ADMIN_URL } from '../../utils/config';

export default function Hall({ selectedHallData, hall, setHall, filial, changePage }) {
    const click = () => {
        if (hall) changePage(3);
    }

    return (
        <>
            <div className={style.container}>
                {Object.entries(JSON.parse(selectedHallData.HallsData)).map(([id, hallData]) => (
                    <div key={`hall-${filial}-${id}`} className={`${style.block} ${(hall === Number(id) && style.selected)}`} onClick={() => setHall(Number(id))}>
                        <img src={`${ADMIN_URL}/assets/img/halls/hall${filial}-${id}.png`} alt={`Зал №${id}`} />
                        <div className={style.text_number}>Зал №{id}</div>
                        <div className={style.text_count}>до {hallData.maxPeople} человек, {hallData.square} м²</div>
                        <div className={style.text_about}>{hallData.info}</div>
                    </div>
                ))}
            </div>
            <Buttons button1={{ text: "Далее", onClick: click, disabled: !hall }} button2={{ text: "Назад", onClick: () => changePage(1) }} />
        </>
    )
}
